<div class="buscar-estudiante-container">
  <!-- Use the global-search container defined in shared.css -->
  <div class="global-search">
    <header>
      <div class="title-group">
        <h1>Buscar estudiante</h1>
      </div>
    </header>
    <div>
      <label>N&uacute;mero de libreta:</label>
      <input #searchInput [(ngModel)]="nroLibreta" type="number" placeholder="N&uacute;mero de Libreta" (keyup.enter)="buscarEstudiante()" />
      <button class="search" (click)="buscarEstudiante()">
        <i class="fas fa-search"></i>
      </button>
    </div>
    <div *ngIf="error" class="error-message" style="width: 100%;">
      <p>{{ error }}</p>
    </div>
  </div>
  <app-estudiante-detail *ngIf="estudiante" [estudiante]="estudiante" [isNew]="isNew" (cancelEdit)="handleCancelEdit()"></app-estudiante-detail>
  <div *ngIf="showRegisterPrompt" class="register-prompt">
    <p>¿Registrar nuevo estudiante con n&uacute;mero de libreta {{ nroLibreta }}?</p>
    <div class="centered-button">
      <button (click)="registerNewEstudiante()" class="new-button">
        <i class="fas fa-id-badge"></i>
        <span>Nuevo</span>
      </button>
    </div>
  </div>
</div>
